<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (dayOfWeek of daysOfWeek | async; track trackBy(dayOfWeek)) {
      <lcs-option [value]="dayOfWeek" id="lcs-option-id-{{ dayOfWeek.dayOfWeek }}">
         {{ dayOfWeek.dayOfWeek }}
      </lcs-option>
      }
   </div>
</ng-template>
